export default "__VITE_ASSET__B1g7i6as__"